import { Button, Checkbox, Modal, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import example from '../../../assets/example.jpg';
import styles from '../index.module.scss';

const ContentEnrichmentModal = ({
    open,
    onConfirm,
    autoLightTypes,
    onAutoLightChange,
    isLoadingSummary,
}) => {
    return (
        <Modal
            title="丰富全文内容"
            open={open}
            okText="继续生成大纲"
            footer={
                <Button onClick={onConfirm} type="primary">
                    确认
                </Button>
            }
            closable={false}
        >
            <div>
                <div>
                    如您的全文需要包含
                    <hl>表，图，公式，代码</hl>
                    ，您可在在下方勾选相应选项，灵感会为您自动生成
                    <Tooltip
                        color="#fff"
                        title={
                            <span
                                style={{
                                    color: '#18191c',
                                    width: '250px',
                                }}
                            >
                                您可根据全文需求需要���选相应的
                                <hl>表，图，公式，代码</hl>
                                <br />
                                在生成大纲后仍可继续进行<hl>添加或删减</hl>
                                <br />
                                点亮后，灵感会自动判断勾选内容需要的具体需求，如图所示：
                                <img
                                    src={example}
                                    style={{
                                        color: '#18191c',
                                        width: '240px',
                                    }}
                                />
                            </span>
                        }
                    >
                        <QuestionCircleOutlined
                            color="#999999"
                            className={styles.summaryIcon}
                            style={{ marginLeft: '4px' }}
                        />
                    </Tooltip>
                </div>
                <div
                    className={styles.summaryChecks}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Checkbox.Group
                        value={autoLightTypes}
                        onChange={onAutoLightChange}
                        disabled={isLoadingSummary}
                    >
                        <Checkbox value="TABLE">表</Checkbox>
                        <Checkbox value="DIAGRAM">图</Checkbox>
                        <Checkbox value="FORMULA">公式</Checkbox>
                        <Checkbox value="CODE">代码</Checkbox>
                        <Checkbox value="DATA">数据</Checkbox>
                    </Checkbox.Group>
                </div>
                <a href="https://lingganfengbao.com/example" target="_blank" rel="noreferrer">
                    查看范文样例
                </a>
            </div>
        </Modal>
    );
};

export default ContentEnrichmentModal;
